<!-- <section>
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-1"></div>
            <div class="col-sm-10 p-0">
                <div class="card">
                    <div class="devcare-card-header">
                        <span class="devcare-sub-header"><i class="fas fa-chalkboard-teacher mr-1"></i> User Claims</span>
                    </div>
                </div>
            </div>
            <div class="col-sm-1"></div>
        </div>
    </div>
</section> -->

<section>
    <p-confirmDialog [baseZIndex]="10000" key="positionDialog" [position]="dialogPosition" rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
    <div class="container-fluid">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">Home</li>
            <li class="breadcrumb-item">Admin</li>
            <li class="breadcrumb-item active">User Claim</li>
        </ol>
    </div>
</section>
<section>
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-12 p-0">
                <div class="card Title-bar-blue">
                    <div class="devcare-card-header">
                        <span class="devcare-sub-header Title-bar-text"><i class="fas fa-search mr-1"></i> User Claim Assignment</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section>
    <div class="row">
        <!-- <div class="col-md-1"></div> -->
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="devcare-card-header">
                            <span class="devcare-card-title">Search</span>
                        </div>
                        <div class="devcare-card-body">
                            <div class="row">
                                <div class="col-md-10">
                                    <form [formGroup]="searchForm">
                                        <div class="p-fluid p-formgrid p-grid">
                                            <div class="p-field p-col-12 p-md-4">
                                                <label for="companyName">Company Name</label>
                                                <p-dropdown id="companyName" formControlName="companyName" (onChange)="companyNameOnChange($event.value)" [options]="companyName" optionLabel="companyName" optionValue="companyId">
                                                </p-dropdown>
                                            </div>
                                            <div class="p-field p-col-12 p-md-4">
                                                <label for="countryCode">User Role</label>
                                                <p-dropdown id="selectedCountry" formControlName="userRole" [options]="userRole"  optionLabel="name" optionValue="id"></p-dropdown>
                                            </div>
                                            <div class="p-field p-col-12 p-md-4">
                                                <label for="userName">User Name</label>
                                                <input id="userName" type="text" formControlName="userName" pInputText>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div class="col-md-2 d-flex align-items-center">
                                    <button pButton pRipple type="button" label="Search" icon="pi pi-search"
                                class="p-button-sm p-button-raised p-button-success m-2" (click)="search()"></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12" *ngIf="isUserList">
                    <div class="card">
                        <div class="devcare-card-header">
                            <span class="devcare-card-title">User List</span>
                        </div>
                        <div class="devcare-card-body" style="overflow: hidden;">
                            <p-table #dt2 [value]="user" [loading]="loading" [resizableColumns]="true" columnResizeMode="expand" styleClass="p-datatable-gridlines">
                            <ng-template pTemplate="colgroup" let-columns>
                                <colgroup>
                                    <col>
                                    <col>
                                    <col>
                                    <col>
                                    <col>
                                    <col>
                                    <col>
                                </colgroup>
                            </ng-template>
                            <ng-template pTemplate="header">
                                <tr>
                                    <th pResizableColumn style="width: 5rem">Action</th>
                                    <th pResizableColumn>User Name</th>
                                    <th pResizableColumn>First Name</th>
                                    <th pResizableColumn>Last Name</th>
                                    <th pResizableColumn>Company Name</th>
                                    <th pResizableColumn>Role</th>
                                    <th pResizableColumn style="width: 8rem">Active</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-claim>
                                <tr>
                                    <td> <a [routerLink]="" class="table-icon table-icon-menu"><i class="pi pi-ellipsis-v"
                                                (click)="selectedGridMenuItem = claim; menu.toggle($event)"></i></a>
                                        <p-menu #menu [popup]="true" [model]="items" appendTo="body"></p-menu>
                                    </td>
                                    <td>
                                        <span>{{claim.userName}}</span>
                                    </td>
                                    <td>
                                        <span>{{claim.firstName}}</span>
                                    </td>
                                    <td>
                                        <span>{{claim.lastName}}</span>
                                    </td>
                                    <td>
                                        <span>{{claim.companyName}}</span>
                                    </td>
                                    <td>
                                        <span>{{claim.accountType}}</span>
                                    </td>
                                    <td>
                                        <!-- <span [class]="'customer-badge status-' + claim.isActive">{{claim.isActive}}</span> -->
                                        <span class="customer-badge status-active" *ngIf="claim.isActive">Active</span>
                                        <span class="customer-badge status-inactive" *ngIf="!claim.isActive">Inactive</span>
                                    </td>
                                    <!-- <td>
                                        <span>
                                            <a [routerLink]="" class="table-icon table-icon-edit" (click)="userPermission(claim.userProfileId, claim.userName)"><i class="fas fa-edit"></i></a>&nbsp;&nbsp;&nbsp;
                                        </span>
                                    </td> -->
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td colspan="5">Sorry!. Users not found for your criteria.</td>
                                </tr>
                            </ng-template>
                        </p-table>
                        </div>
                    </div>
                </div>
                <div class="col-md-12" *ngIf="isUserPermission">
                    <div class="card">
                        <div class="devcare-card-header">
                            <span class="devcare-card-title"> User Permissions - {{ userProfileUserName}}</span>
                        </div>
                        <div class="devcare-card-body" style="overflow: hidden;">
                            <p-table #upt [value]="userClaim" [loading]="userPermissionsLoading">
                                <ng-template pTemplate="colgroup" let-columns>
                                    <colgroup>
                                        <col>
                                        <col>
                                        <col>
                                        <col>
                                        <col>
                                        <col>
                                    </colgroup>
                                </ng-template>
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Features</th>
                                        <th>View</th>
                                        <th>Add</th>
                                        <th>Delete</th>
                                        <th>Export</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-data let-editing="editing" let-ri="rowIndex">
                                    <tr>
                                        <td><span style="color: black;">{{data.featureName}}</span></td>
                                        <td *ngFor="let value of data.claimTypeView" pEditableColumn>
                                            <p-cellEditor>
                                                <ng-template pTemplate="input">
                                                    <p-checkbox [(ngModel)]="value.hasPermission" binary="true" inputId="binary"></p-checkbox>
                                                </ng-template>
                                                <ng-template pTemplate="output">
                                                    <p-checkbox [(ngModel)]="value.hasPermission" binary="true" inputId="binary"></p-checkbox>
                                                </ng-template>
                                            </p-cellEditor>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="5">No Data found.</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="col-md-1"></div> -->
    </div>

</section>
<section *ngIf="isUserPermission">
    <div class="row">
      <div class="col-md-1"></div>
      <div class="col-md-10">
        <button pButton pRipple type="button" label="Cancel" icon="pi pi-times"
          class="p-button-outlined p-button-sm p-button-danger float-right m-2 bg-primary" (click)="cancelClaim()"></button>
        <button pButton pRipple type="button" label="Save" icon="pi pi-check"
          class="p-button-outlined p-button-sm p-button-success float-right m-2 bg-success" (click)="saveClaim()"></button>
      </div>
      <div class="col-md-1"></div>
    </div>
  </section>